export default {
  FULL: "full",
  PARTIAL: "partial",
  BUSY: "busy",
  CURRENT: "current",
  UNAVAILABLE: "unavailable",
  DIFFERENT_MODE: "different_mode",
  FREE: "free",
};
